import { useGuideStore } from "./useGuideStore";

export const getGuideAnalyticData = () => {
    const {
        currentGuideName,
        analyticsInfo: { currentStepId, completedSteps, completedStepCount },
    } = useGuideStore.getState();
    return {
        guide: currentGuideName,
        currentStepId,
        completedSteps,
        completedStepCount: completedStepCount ?? 0,
    };
};
